module.exports = __webpack_public_path__ + "img/car-inside-second.4e584d7e.jpg";